<template>
  <div class='box-quote'>
    <!--      商业化营销中心终价-报价明细-->
    <div class='mb8 panel-border'>
      <AdjustPricePanel
        :key='`real_pg_${formData.id}`'
        :show-reset='false'
        ref='refRealQuotePanel'
        @handleReset='handleReset'
        :quote-info.sync='formData.real_quote'
        :show-single-price='priceTypeMap.single'
        :show-multi-price='priceTypeMap.multi'
        :show-mixed-price='priceTypeMap.mixed'
        :platform-type='platformType'
        :title='`商业化营销中心终价`'
        :edit-price='true' />
    </div>

    <div style='text-align: center'>
      <el-button type='primary' size='medium' @click='saveQuote' :disabled='loadingSb' :loading='loadingSb'
                 v-if="userPermissions.indexOf('plc_save_quote')>-1" round>
        保存并确认终价
      </el-button>
      <el-button @click='notifyByDing' size='medium' v-if="userPermissions.indexOf('plc_save_quote')>-1"
                 :disabled='loadingNotify' :loading='loadingNotify' round>
        通知定价
      </el-button>
    </div>

    <div v-if='showSetJson'>
      <JsonDisplay :value='{platformType:platformType,real_quote:formData.real_quote}'
                   title='报价信息'
                   :show-copy='true'
                   :show-format='true'
                   :show-char-count='true'
                   :bordered='false'
                   copy-text='复制'></JsonDisplay>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PriceGrids from '@/pages/plc/compoents/PriceGrids'
import AdjustPricePanel from './AdjustPricePanel'
import plcMap from '@/json/plc.json'
import PriceStructView from '@/pages/plc/compoents/PriceStructView'
import { html2json } from 'html2json'
import JsonDisplay from '@/components/display/JsonDisplay.vue'

const { deepClone } = require('@/utils')
// 报价信息-数据结构
const quoteStruct = plcMap.form.quoteStruct

export default {
  name: 'PlcRealQuoteEdit',
  components: { JsonDisplay, PriceStructView, AdjustPricePanel, PriceGrids },
  computed: {
    ...mapGetters(['userPermissions']),
    //报价方式：品类报价（1：n）；类目报价
    priceTypeMap() {
      const customPriceMap = plcMap.customPriceMap

      return customPriceMap[this.platformType] || {
        'multi': true,
        'single': true,
        'mixed': true,
        'showLast': true
      }
    }
  },
  props: {
    id: {
      type: [Number, String],
      default() {
        return null
      }
    },
    platformType: {
      type: String,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      formData: {
        id: null,
        quote_source: null,
        current_quote: quoteStruct,
        next_quote: quoteStruct,
        real_quote: quoteStruct
      },
      loadingSb: false,
      showSetJson: false,
      loadingNotify: false
    }
  },
  methods: {
    init(row) {
      this.formData = { ...row }
      // if (this.formData.real_quote) {
      //   if (this.formData.real_quote.multi) {
      //     //扁平化数组，如果第一项是空数组的话，则格式化 [{}]
      //     if (this.formData.real_quote.multi.flat(Infinity).length === 0) {
      //       this.formData.real_quote.multi = [{}]
      //     }
      //   }
      // }
      // 若未定价
      if (this.formData.status === 1) {
        //定价明细默认为本期估计（若未定价）
        this.formData.real_quote = { ...this.formData.next_quote }
      }
      this.$nextTick(() => {
        this.$refs['refRealQuotePanel'].show()
      })

    },
    handleReset() {
      this.formData.real_quote = { ...quoteStruct }
      this.formData.quote_source = this.formData?.quote_source ? null : null
      this.$forceUpdate()
    },
    async getInfo() {
      if (this.id) {
        const { info } = await this.$api.getPublicationItemInfo(this.id)
        this.$nextTick(() => {
          const { id, quote_source, current_quote, next_quote, real_quote } = info
          this.formData = {
            id: id,
            quote_source: quote_source,
            current_quote: current_quote,
            next_quote: next_quote,
            real_quote: real_quote || { ...quoteStruct }
          }
          this.$forceUpdate()
        })
      }
    },
    handleRichTxt() {
      const keys = Object.keys(this.formData.real_quote.mixed)
      keys.forEach((key) => {
        this.$set(this.formData.real_quote.mixed[key], 'rich_txt', html2json(this.formData.real_quote.mixed[key].val))
      })
      // this.$set(this.formData.real_quote.mixed.sri, 'rich_txt', html2json(this.formData.real_quote.mixed.sri.val))
      // this.$set(this.formData.real_quote.mixed.mfr, 'rich_txt', html2json(this.formData.real_quote.mixed.mfr.val))
      // this.$set(this.formData.real_quote.mixed.scs, 'rich_txt', html2json(this.formData.real_quote.mixed.scs.val))
    },
    async saveQuote() {
      //保存最终价格
      this.loadingSb = true
      //富文本处理
      if (this.priceTypeMap.mixed) {
        this.handleRichTxt()
        // // 纠正历史数据问题（之后可删除该代码）
        // if (this.formData.real_quote.mixed.pfc)
        //   delete this.formData.real_quote.mixed.pfc
      }

      // 校对报价信息：不报价的项目数据清空
      if (!this.priceTypeMap.single) {
        if (this.formData.real_quote.single)
          this.formData.real_quote.single = []
      }

      if (!this.priceTypeMap.multi) {
        if (this.formData.real_quote.multi)
          this.formData.real_quote.multi = []
      }

      if (!this.priceTypeMap.mixed) {
        if (this.formData.real_quote.mixed)
          this.formData.real_quote.mixed = {}
      }

      const params = { id: this.formData.id, real_quote: this.formData.real_quote }
      if (this.formData.quote_source) {
        params['quote_source'] = this.formData.quote_source
      }
      const id = await this.$api.saveRealQuote(params)
      if (id) {
        this.$emit('saved', this.formData.real_quote)
      }
      this.loadingSb = false

    },
    selectQuote(quotes, quote_source) {
      this.formData.quote_source = quote_source
      this.formData.real_quote = deepClone(quotes)
      //重新渲染报价组件
      this.$refs['refRealQuotePanel'].show()
    },
    async notifyByDing() {
      this.loadingNotify = true
      // this.$notify.warning('定价通知：定价与你的预估价格不同，通知知晓！！！（开放中...）')
      await this.$api.handleRealQuoteNotify(this.formData.id)
      this.$notify.success('通知已发送')
      this.loadingNotify = false
    }
  }
}
</script>

<style scoped>
.box-quote {
  box-sizing: border-box;
  /*width: clamp(800px, 90%, 100%);*/
  width: 100%;
  /*border: #f2f2f2 1px dashed;*/
  padding: 2px;
}

.choice-quote {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 8px;
  width: 100%;
}

.panel-border {
  border: #f2f2f2 1px dashed;
  padding: 2px;
}

.opt-title {
  font-weight: bold;
  font-size: 14px;
  padding: 5px;
  border-radius: 10px 10px;
  margin-bottom: 8px;
}

.price-box {
  /*box-sizing: unset;*/
  width: clamp(760px, 100%, 960px);
  border: #f2f2f2 1px dashed;
  padding: 2px;
  display: inline-block
}

.quote-input {
  margin-bottom: 5px;
}

.edit-box {
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.check-btn {
  margin-left: 10px;
}

.item {
  display: flex;
}

.is-label {
  flex: 3;
}

.item-val {
  flex: 3;
  margin-left: 5px;
}

.item-remark {
  flex: 5;
  margin-left: 5px;
}
</style>
